<template>
  <div>
    <v-card
      tile
      flat
      class="headingcardsCat"
      img="https://sitkatheme.com/travel/wp-content/uploads/sites/7/2019/10/travl6-1920x1374.jpg"
    >
      <div class="filtro">
        <v-card-text class="aling-items-center text-center titular">
          <b-container>
            <h2 class="titulo">Categoría</h2>

            <h4 class="categoria">Noticias</h4>
          </b-container>
        </v-card-text>
      </div>
    </v-card>
    <b-container>
      <b-row>
        <b-col cols="12" md="8">
          <v-card class="py-5 cardsHomeEntradas mx-0" v-for="noticia in noticias" :key="noticia.id"  elevation="0" >
              <v-img class="white--text align-end" height="200px" :src="noticia.portada">
                <div class="text-right p-3">
                  <v-icon class="rippleBlog">mdi-calendar</v-icon>
                  {{noticia.fecha}}
                </div>
              </v-img>

              <v-card-text class="m-0 p-0">
                <div class="py-3 etiquetaInner text-uppercase">
                  <a :href="noticia.hrefcategoria">{{noticia.categoria}}</a>
                </div>

                <div class="pb-5 tituloInner">Titulo</div>

                <div
                  class="pb-5"
                >Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea laborum aspernatur vero labore aliquid hic eaque vel.</div>
              </v-card-text>
              <v-card-actions class="p-0">
                <v-btn text class="violeta text-bold" :href="noticia.href">
                  Leer más
                  <v-icon right class="violeta">mdi-chevron-triple-right</v-icon>
                </v-btn>
              </v-card-actions>
          </v-card>
        </b-col>
        <b-col cols="12" md="4" lg="4">
          <ColumnaDer />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ColumnaDer from "../../components/ColumnaDer";

export default {
  components: {
    ColumnaDer
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
    this.$store.dispatch("categorias/listarCategoriaNoticias");
  },
  computed: {
    noticias() {
      return this.$store.getters["categorias/verNoticias"];
    }
  }
};
</script>